export const lineChartDataSubscription = {
	//title: 'Evolution des abonnements par trimestre',
	absisse: [],

	taux: {
		name: 'Taux',
		values: [],
	},
	abonnes: {
		name: 'Nouveaux abonnés',
		values: [],
	},
	encaisse: {
		name: 'Dépôt de garantie encaissés',
		values: [],
	},
};

export const lineChartDataResiliation = {
	//title: 'Evolution des résiliations par trimestre',
	absisse: [],

	taux: {
		name: 'Taux',
		values: [],
	},
	abonnes: {
		name: 'Abonnés resiliés',
		values: [],
	},
	encaisse: {
		name: 'Dépôt de garantie décaissés',
		values: [],
	},
};

const getRandomIntInclusive = (min: number, max: number) => {
	min = Math.ceil(min);
	max = Math.floor(max);
	return Math.floor(Math.random() * (max - min + 1)) + min;
};

export const tableau_1 = {
	title: "Secteurs d'activités enregistrant des résiliations significatives ",
	headers: [
		{
			field: 'text',
			headerName: 'Secteurs',
		},
		// {
		//   field: "number",
		//   headerName: "Dépôt de garantie encaissés",
		// },
		{
			field: 'number',
			headerName: 'Dépôt de garantie remboursés',
		},
		// {
		//   field: "number",
		//   headerName: "Dépôt de garantie restant",
		// },
		{
			field: 'number',
			headerName: 'Abonnés résiliés',
		},
		{
			field: 'action',
			headerName: 'Actions',
		},
	],
	rows: [
		{
			secteur: 'ADMINISTRATION',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AGR INDUSTRIE',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AGR VIVRIER',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BOISSON',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BATIMENT',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BRANCHEMENT',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AUTRES',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'ADMINISTRATION',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AGR INDUSTRIE',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AGR VIVRIER',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BOISSON',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BATIMENT',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BRANCHEMENT',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AUTRES',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'ADMINISTRATION',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AGR INDUSTRIE',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AGR VIVRIER',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BOISSON',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BATIMENT',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'BRANCHEMENT',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
		{
			secteur: 'AUTRES',
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50, 5000),
		},
	],
	titleExport: 'export_tab_des_secteurs',
	colsToExport:
		'secteur|Secteurs,asc_encaisse|Dépôt de garantie encaissés,asc_rembourse|Dépôt de garantie remboursés,asc_restant|Dépôt de garantie restant,total_abonne|Nouveaux abonnés',
};

export const tableau_abonnement = {
	title: 'Tableau des abonnements',
	headers: [
		{
			field: 'text',
			headerName: 'Mois Année',
		},
		{
			field: 'number',
			headerName: 'Montant total restant',
		},
		{
			field: 'number',
			headerName: 'Dépôt encaissé',
		},
		{
			field: 'number',
			headerName: 'Nombre abonnés actifs',
		},
		// {
		//   field: "number",
		//   headerName: "Dépôt de garantie restants",
		// },
		// {
		//   field: "number",
		//   headerName: "Abonnés actifs",
		// },
		// {
		//   field: "number",
		//   headerName: "Abonnés résiliés",
		// },
		{
			field: 'action',
			headerName: 'Actions',
		},
	],
	rows: [
		{
			date: 'janvier 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(500, 300),
		},
		{
			date: 'février 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'mars 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'avril 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'mai 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'juin 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'juillet 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'août 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'septembre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'octobre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'novembre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'décembre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'janvier 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'février 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'mars 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'avril 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
		{
			date: 'mai 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
			total_abonne: getRandomIntInclusive(50000, 30000),
		},
	],
	titleExport: 'export_tab_des_abonnement',
	colsToExport:
		'date|Mois année, total_restant|Montant total restant, asc_encaisse|Dépôt de garantie encaissés, total_abonne|Total abonnés',
};

export const tableau_resiliation = {
	title: 'Tableau des résiliations',
	headers: [
		{
			field: 'text',
			headerName: 'Mois année',
		},
		{
			field: 'number',
			headerName: 'Montant total restant',
		},
		{
			field: 'number',
			headerName: 'Dépôts remboursement',
		},
		{
			field: 'number',
			headerName: 'Nombre abonné résilié',
		},
		// {
		//   field: "number",
		//   headerName: "Dépôt de garantie restants",
		// },
		// {
		//   field: "number",
		//   headerName: "Abonnés actifs",
		// },
		// {
		//   field: "number",
		//   headerName: "Abonnés résiliés",
		// },
		{
			field: 'action',
			headerName: 'Actions',
		},
	],
	rows: [
		{
			date: 'janvier 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(1000, 3000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'février 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'mars 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'avril 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'mai 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'juin 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'juillet 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'août 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'septembre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'octobre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'novembre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'décembre 2022',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'janvier 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'février 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'mars 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'avril 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
		{
			date: 'mai 2023',
			total_restant: getRandomIntInclusive(10000000, 3000000000),
			asc_rembourse: getRandomIntInclusive(10000000, 3000000000),
			total_resilie: getRandomIntInclusive(50000, 30000),
			// asc_encaisse: getRandomIntInclusive(10000000, 3000000000),
			// asc_restant: getRandomIntInclusive(10000000, 3000000000),
		},
	],
	titleExport: 'export_tab_des_resiliation',
	colsToExport:
		'date|Mois année, total_restant|Montant total restant, asc_rembourse|Dépôt de garantie remboursés, total_resilie|Total résilié',
};

export const tableau_3 = {
	title: 'Liste des utilisateurs',
	headers: [
		{
			field: 'text',
			headerName: '#',
		},
		{
			field: 'text',
			headerName: 'Nom',
		},
		{
			field: 'text',
			headerName: 'Prénoms',
		},
		{
			field: 'text',
			headerName: 'Adresse e-mail',
		},
		{
			field: 'text',
			headerName: 'Profil',
		},
		{
			field: 'number',
			headerName: 'Contact',
		},
		{
			field: 'number',
			headerName: 'Statut',
		},
		{
			field: 'action',
			headerName: 'Actions',
		},
	],
	rows: [
		{
			index: '1',
			name: 'Fofana',
			surname: 'Soualio',
			matricule: 'R-00232022',
			email: 'fofanasoualison18@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '2',
			name: 'Adou',
			surname: 'Venance',
			matricule: 'R-00232022',
			email: 'adou.venance@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '3',
			name: 'Soro',
			surname: 'Ange',
			matricule: 'R-00232022',
			email: 'soro.ange@gmail.com',
			profil: 'Adou',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '4',
			name: 'Kouadio',
			surname: 'Aimeric',
			matricule: 'R-00232022',
			email: 'kouadio.aimeric@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '5',
			name: 'Aka',
			surname: 'Cyrille',
			matricule: 'R-00232022',
			email: 'aka.cyrille@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '6',
			name: 'Etty',
			surname: 'Aima',
			matricule: 'R-00232022',
			email: 'etty.aima@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '7',
			name: 'Coulibaly',
			surname: 'tiorna',
			matricule: 'R-00232022',
			email: 'coulibalytiorna@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '8',
			name: 'Yeo',
			surname: 'Moussa',
			matricule: 'R-00232022',
			email: 'yeomoussa@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '9',
			name: 'Ano',
			surname: 'Raymond',
			matricule: 'R-00232022',
			email: 'anoraymond@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '10',
			name: 'Tambie',
			surname: 'Alexis',
			matricule: 'R-00232022',
			email: 'tambiealexis@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '11',
			name: 'Yamb',
			surname: 'Landry',
			matricule: 'R-00232022',
			email: 'yamblandry@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '12',
			name: 'Adjouroufou',
			surname: 'Yannick',
			matricule: 'R-00232022',
			email: 'adjouroufouyannick@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '13',
			name: 'Akpablin',
			surname: 'Ives',
			matricule: 'R-00232022',
			email: 'akpablinives@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '14',
			name: 'Konan',
			surname: 'Sérafin',
			matricule: 'R-00232022',
			email: 'konanserafin@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '15',
			name: 'Diarrassouba',
			surname: 'Chacoul',
			matricule: 'R-00232022',
			email: 'diarrassoubachacoul@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '16',
			name: 'Coulibaly',
			surname: 'Bara',
			matricule: 'R-00232022',
			email: 'coulibalybara@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
		{
			index: '17',
			name: 'Sapohi',
			surname: 'Liliane',
			matricule: 'R-00232022',
			email: 'sapohililiane@gmail.com',
			profil: 'Administrareur',
			contact: '0767509622',
			statut: 'Actif',
		},
	],
	titleExport: 'export_tab_des_utilisateurs',
	colsToExport:
		'nom|Nom,prenoms|Prénoms,email|Email,profil_id|Profil,telephone|Télephone',
};

export const tableau_logs = {
	title: 'Historique des connexions',
	headers: [
		{
			field: 'text',
			headerName: 'Date de connexion',
		},
		{
			field: 'text',
			headerName: 'Nom',
		},
		{
			field: 'text',
			headerName: 'Prénoms',
		},
		{
			field: 'text',
			headerName: 'Adresse e-mail',
		},
	],
	rows: [],
	titleExport: 'export_historique_connexion',
	colsToExport:
		'date|Date de connexion,nom|Nom,prenoms|Prénoms,email|Email',
};
